import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import { Box, Flex, P } from 'ui/acro'

import { Blockquote, Text, Caption, Button } from 'ui/bend'
import { useWindowResize } from 'hooks'

const HeaderText = styled(Blockquote)((props) =>
  css({
    fontSize: ['20px','24px'],
    fontWeight: '600',
    lineHeight: ['135%','32px'],
    letterSpacing: '0px',
    textTransform: 'uppercase',
    textAlign: 'left',
    fontFamily: props.theme.fonts.Proxima
  })
)

const HeaderCTAText = styled(Text)(() =>
  css({
    fontFamily: 'Proxima-Nova',
    fontSize: '14px',
    letterSpacing: '0.308px',
    textDecorationLine: 'underline',
    textUnderlinePosition: 'from-font'
  })
)

const CTAText = styled(Caption)(() =>
  css({
    fontSize: '12px',
    lineHeight: '135%',
    textTransform: 'uppercase'
  })
)

const Section = ({
  headerText,
  linkId,
  linkHref,
  cta,
  target,
  title,
  children
}) => {
  const { width } = useWindowResize()
  const isMobile = width <= 480
  return (
    <div>
      <Flex
        mb={['8px', '8px', '8px', '8px']}
        mt={['16px', '16px', '16px', '0px']}
        justifyContent='space-between'
        alignItems='center'
      >
        <Flex flexDirection='column'>
          <CTAText>{title}</CTAText>
          <HeaderText as='div'>{headerText}</HeaderText>
        </Flex>
        {!isMobile && (
          <HeaderCTAText
            id={linkId}
            as='a'
            className='unstyled'
            href={linkHref}
            target={target}
          >
            <span>{cta}</span>
          </HeaderCTAText>
        )}
      </Flex>
      {children}
      {isMobile && linkHref && (
        <Button
          onClick={() => (window.location.href = linkHref)}
          height='24px'
          width='100%'
          mt='24px'
          variant='ouline'
          style={{fontSize: '16px', fontWeight: 500}}
        >
          {cta}
        </Button>
      )}
    </div>
  )
}

Section.propTypes = {
  headerText: PropTypes.string.isRequired,
  linkId: PropTypes.string,
  linkHref: PropTypes.string,
  cta: PropTypes.string,
  target: PropTypes.string
}

export default Section
